import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home, MessageCircle, RefreshCw, Sparkles } from "lucide-react";

import SystemPageShell from "./SystemPageShell";

export default function ServerErrorPage({ resetError }) {
  useEffect(() => { document.title = "Something Went Wrong | SugaLumps"; }, []);
  return (
    <SystemPageShell
      eyebrow="Something got a little messy"
      title="We hit a kitchen mishap."
      copy="Something went wrong on our side. Your sweets are safe — please try again in a moment."
      icon={<Sparkles size={38} strokeWidth={1.5} />}
      actions={(
        <>
          <button className="sl-system-button primary" type="button" onClick={resetError || (() => window.location.reload())}><RefreshCw size={16} /> Try Again</button>
          <Link className="sl-system-button secondary" to="/"><Home size={16} /> Back Home</Link>
          <Link className="sl-system-button secondary" to="/contact"><MessageCircle size={16} /> Contact Us</Link>
        </>
      )}
    />
  );
}
